import type { ClinicianUpgradeCheckoutSeat } from '@heidi/commerce';
import { getUsageLimitsHelpUrl } from '@heidi/commerce/data';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

/** The clinician seat checkout that sits between the T-7 modal and Stripe. */
export const CLINICIAN_UPGRADE_CHECKOUT_PATH = '/settings/billing/clinician-upgrade';

export const BILLING_SETTINGS_PATH = '/settings/billing';

/** Query parameter that preselects a seat on the checkout. */
export const CLINICIAN_UPGRADE_CHECKOUT_SEAT_PARAM = 'seat';

export function useOpenClinicianCheckout(): (options?: {
  seat?: ClinicianUpgradeCheckoutSeat;
}) => void {
  const router = useRouter();
  return useCallback(
    (options) => {
      void router.push(
        options?.seat
          ? {
              pathname: CLINICIAN_UPGRADE_CHECKOUT_PATH,
              query: { [CLINICIAN_UPGRADE_CHECKOUT_SEAT_PARAM]: options.seat },
            }
          : CLINICIAN_UPGRADE_CHECKOUT_PATH
      );
    },
    [router]
  );
}

/** The seat a checkout link asks for, or `undefined` for the default. */
export const parseClinicianCheckoutSeat = (
  value: string | string[] | undefined
): ClinicianUpgradeCheckoutSeat | undefined =>
  value === 'standard' || value === 'max' ? value : undefined;

export function useOpenBillingSettings(): () => void {
  const router = useRouter();
  return useCallback(() => {
    void router.push(BILLING_SETTINGS_PATH);
  }, [router]);
}

// The yearly offer has no conditions article of its own yet; the usage limits
// article stands in until marketing publishes one.
export const getOfferConditionsUrl = (locale?: string): string =>
  getUsageLimitsHelpUrl(locale);
